export default __webpack_public_path__ + "static/media/icon_project_ob.fe91a90a.svg";